import React from "react";
import ReactDom from "react-dom";

/**Import Styles  */
import styles from "./DeleteModal.module.scss";

/**Import Components */
import { MdOutlineCancel } from "react-icons/md";

export default function DeleteModal({
  text = "Are you sure you want to delete?",
  handleClose,
  handleDelete,
}) {
  return ReactDom.createPortal(
    <div className={styles.modal}>
      <div className={styles.outside} onClick={handleClose}></div>

      <div className={styles.content}>
        <div className={styles.cross} onClick={handleClose}>
          <MdOutlineCancel />
        </div>
        <img src="images/common/delete.svg" alt="Delete" />

        <h1 className={styles.header}>{text}</h1>
        <div className={`${styles.buttonContainer}`}>
          <button className={styles.edit} onClick={handleClose}>
            Cancel
          </button>
          <button
            onClick={handleDelete}
            className={`${styles.delete} ${styles.deleted}`}
          >
            Delete
          </button>
        </div>
      </div>
    </div>,
    document.getElementById("video_portal")
  );
}
